import { Theme } from '@livecontrol/core-ui';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';

import G = Matrix.Grid;
import H = G.Header;
import C = G.Row.Cell;

interface Props {
  routers: {
    id: string;
    name?: string;
    status?: string;
  }[];
}

export const RouterGrid = ({ routers }: Props): React.ReactElement => {
  const viewport = Theme.useViewport();

  return (
    <G viewport={viewport} gridTemplateColumns='repeat(2, 1fr)'>
      {/* Header */}
      <G.Row>
        <H viewport={viewport}>Name</H>
        <H viewport={viewport}>Status</H>
      </G.Row>

      {
        /* Content */
        routers
          .map(
            (router): React.ReactElement => (
              <G.Row key={router.id}>
                <C>
                  <a
                    className='text-white font-weight-bold text-left m-0'
                    href={`https://app.cloutik.us/device/devices/${router.id}`}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {router.name} <i className='far fa-external-link ml-4px' />
                  </a>
                  </C>
                <C>{router.status ?? ''}</C>
              </G.Row>
            )
          )
      }
    </G>
  );
};
